import { BlogPage, MetaData } from '@/components'

export default function NextBlogPage(props) {
  const { meta } = props.paginator;
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || "ELEMENTAL Day Surgical Center Blog";
  const description = descFromProps
  return (
    <>
      <MetaData title={title} description={description} />
      <BlogPage {...props} />
    </>
  )
}

NextBlogPage.getInitialProps = async ({ query, api }) => {
  const { page, ...queries } = query
  const response = await api.articles(page, queries)

  const { ...paginator } = response
  return { paginator }
}
